
import axios from "axios"

axios.interceptors.response.use(config=>{
  
  return config.data;
},err=>{
  Promise.reject(err)
})

export default axios;